<template>
	<div class="component openplayer openplayer-container">
		<video 
			class="op-player op-player__media" 
			:id="id" 
			:controls="showControls"
			:poster="poster"
			:playsinline="playsInline"
		>
			<source v-if="streamUrl" :src="streamUrl" type="application/x-mpegURL">
			<source v-else-if="encodedUrl" :src="encodedUrl" type="video/mp4">
		</video>
	</div>
</template>

<script>
import OpenPlayerJS from 'openplayerjs'; // Correct import
import 'openplayerjs/dist/openplayer.css';

export default {
	props: {
		id: {
			type: String,
			required: true
		},
		title: {
			type: String,
			default: 'unknown'
		},
		encodedUrl: {
			type: String,
			required: false
		},
		streamUrl: {
			type: String,
			required: false
		},
		isEmbeddable: {
			type: Boolean,
			default: true
		},
		isEmbed: {
			type: Boolean,
			default: false
		},
		embedCode: {
			type: String,
			default: ''
		},
		autoplay: {
			type: Boolean,
			default: false
		},
		muted: {
			type: [Boolean, String],
			default: 'auto'
		},
		poster: {
			type: String,
			required: false
		},
		playsInline: {
			type: Boolean,
			default: true
		},
		showControls: {
			type: Boolean,
			default: true
		},
		ads: {
			type: Object,
			default () {
				return {
					'website': false,
					'app': false
				};
			}
		},
		adsVastUrls: {
			type: Array,
			default: () => ([{
					'name': 'google',
					'url': 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',
				},
				{
					'name': 'glomex',
					'url': 'https://glomex.github.io/vast-ima-player/linear-ad.xml',
				}
			])
		},
	},
	data() {
		return {
			$player: null
		};
	},
	mounted() {
		this.initializePlayer();
	},
	beforeUnmount() {
		if (this.player) {
			this.player.destroy();
			this.player = null;
		}
	},
	methods: {
		initializePlayer() {
			var component = this;
			
			const options = {
				controls: {
					alwaysVisible: false,
					layers: {
						left: ['play', 'time', 'volume'],
						middle: ['progress'],
						right: ['captions', 'settings', 'fullscreen'],
					}
				},
				detachMenus: false,
				forceNative: true,
				mode: 'responsive',
				hidePlayBtnTimer: 350,
				showLoaderOnInit: false,
				useDeviceVolume: false,
				pauseOthers: true,
				muted: this.muted,
			};
			
			// HLS
			options.hls = {
			};
			
			// https://www.skoften.net/feeds/vast-test.xml
			
			// Ads 
			if(component.ads == true) {
				options.ads = {
					src: [
						'https://www.skoften.net/feeds/vast-test.xml'
					],
					vpaidMode: true,
					loop: false,
					numRedirects: 6,
					sdkPath: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
					debug: false,
					enablePreloading: true,
					language: 'nl',
				}
			}
			
			// Create player instance
			this.player = new OpenPlayerJS(this.id, options);

			// Bind components
			component.bindEvents();
			
			// Init
			this.player.init();
		},
		mute() {
			this.$logger('app/component/open-player/mute');
			var player = this.$player.getElement();
			player.muted = true;
		},
		unMute() {
			this.$logger('app/component/open-player/unMute');
			var player = this$.player.getElement();
			player.muted = false;
		},
		toggleMute() {
			this.$logger('app/component/open-player/toggleMute');
			
			var player = this.$player.getElement();
			if(player.muted) {
				player.muted = false;
			} else {
				player.muted = true;
			}
		},
		bindEvents() {

			var component = this;
			var player = this.player.getElement();
						
			component.$logger('app/component/open-player/bind-events');
			
			// Video events
			player.addEventListener('canplay', () => {
				component.$logger('app/component/open-player/event:canplay (' + this.id + ')');
								
				// Muted
				if(component.muted == true) {
					component.$logger('app/component/open-player/set/muted:true (' + this.id + ')');
					player.muted = true;
				} else if(component.muted == false) {
					player.muted = false;
				} else {
					// auto
				}
				
				// Controls
				if(component.controls == true) {
				}	
							
				// Autoplay
				if(component.autoplay) {
					component.$logger('app/component/open-player/set/autoplay (' + this.id + ')');				
					player.muted = true;
					player.play();
				}
			});

			player.addEventListener('playererror', function(e) {
				component.$logger('app/component/open-player/error (' + this.id + ')');
				component.$logger(e); // { type, message, data }
			});

			player.addEventListener('play', () => {
				component.$logger('app/component/open-player/event:play (' + this.id + ')');
			});

			player.addEventListener('pause', () => {
				component.$logger('app/component/open-player/event:pause (' + this.id + ')');
			});

			player.addEventListener('ended', () => {
				component.$logger('app/component/open-player/event:ended (' + this.id + ')');
			});

			player.addEventListener('controlshidden', () => {
				component.$logger('app/component/open-player/event:controlshidden (' + this.id + ')');
			});

			// Ads events
			player.addEventListener('adsloaded', () => {
				component.$logger('app/component/open-player/event:adsloaded (' + this.id + ')');
			});
			player.addEventListener('adsimpression', () => {
				component.$logger('app/component/open-player/event:adsimpresion (' + this.id + ')');
			});
		}
	}
};
</script>

<style>
	.openplayer-container {
		width: 100%;
		max-width: 800px;
		margin: auto;
	}
	.op-player {
		width: 100%;
		height: auto;
	}
</style>
